// Delivery promise shown as "[date]": orders before noon ship the same working day.
// data-lead="early,late" = working days until delivery before / after the noon cut-off
// (CZ and SK: 1,2; other countries: 2,3). Weekends never count and are never promised.
(() => {
  const addWorkingDays = (from, days) => {
    const date = new Date(from);
    let left = days;
    while (left > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) left -= 1;
    }
    return date;
  };

  const fill = (el) => {
    const [early, late] = (el.dataset.lead || '1,2').split(',').map(Number);
    const now = new Date();
    const weekend = now.getDay() === 0 || now.getDay() === 6;
    const date = addWorkingDays(now, weekend || now.getHours() >= 12 ? late : early);
    let text;
    try {
      text = new Intl.DateTimeFormat(el.dataset.locale || document.documentElement.lang || undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'numeric',
      }).format(date);
    } catch (error) {
      text = `${date.getDate()}. ${date.getMonth() + 1}.`;
    }
    el.textContent = (el.dataset.template || '[date]').replace('[date]', text);
  };

  window.YtEta = { fill };
  const run = () => document.querySelectorAll('[data-yt-eta]').forEach(fill);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
